module.exports = "<p>\n  income-tax-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/organisation-profile/income-tax/income-tax-form/income-tax-form.component.html
// module id = ./src/app/hrms/payroll/organisation-profile/income-tax/income-tax-form/income-tax-form.component.html
// module chunks = main